import { render, staticRenderFns } from "./Base-Input-Numeric.vue?vue&type=template&id=0597dc09&scoped=true&"
import script from "./Base-Input-Numeric.vue?vue&type=script&lang=js&"
export * from "./Base-Input-Numeric.vue?vue&type=script&lang=js&"
import style0 from "./Base-Input-Numeric.vue?vue&type=style&index=0&id=0597dc09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0597dc09",
  null
  
)

export default component.exports